import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeaveIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	x: 0,
	y: 0,
	viewBox: "0 0 16 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.leave-icon-st0{fill:currentColor;}\n"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "leave-icon-st0",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.73077 2.26878L0 2.26878V0.345703L6.73077 0.345703C7.78846 0.345703 8.65384 1.21109 8.65384 2.26878V4.38191H6.73077V2.26878ZM6.73077 13.6127V15.7303L0 15.7303V17.6534H6.73077C7.78846 17.6534 8.65385 16.788 8.65385 15.7303V13.6127H6.73077Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "leave-icon-st0",
			d: "M11.6067 8.23077L9.1259 5.74038L10.4817 4.38462L15.2894 9.19231L10.4817 14L9.1259 12.6442L11.6067 10.1538L2.30859 10.1538L2.30859 8.23077L11.6067 8.23077Z"
		})
	]
});
export default SvgLeaveIcon;
